import styled from 'styled-components';
import { Button } from 'ui/button';
import { TooltipContent } from 'ui/tooltip/Tooltip.styled';
import { spacing, body2, colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const ErrorTooltipContent = styled(TooltipContent)`
  background: ${colors.textDestructive};
  box-shadow: none;
`;

export const StyledTriggerButton = styled(Button)`
  ${body2};
  width: fit-content;
  min-width: ${pxToRem(25)};
  max-width: 25cqw;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  column-gap: ${spacing.half};
  height: ${spacing.double};
  padding: ${spacing.half};

  && {
    &[data-empty='true'] {
      box-shadow: none;
      svg:not(.shape) path {
        stroke: ${colors.textLink};
      }
      svg.shape {
        color: ${colors.textLink};
      }
      svg[data-temporary-fix] path {
        fill: ${colors.textLink};
        stroke: none;
      }
    }
    &[data-empty='false'] {
      box-shadow: none;
      svg:not(.shape) path {
        stroke: ${colors.purple50};
      }
      svg.shape {
        color: ${colors.purple50};
      }
      svg[data-temporary-fix] path {
        fill: ${colors.purple50};
        stroke: none;
      }
    }
    &[data-warning='true'] {
      svg:not(.shape) path {
        stroke: ${colors.textWarning};
      }
      svg.shape {
        color: ${colors.textWarning};
      }
      svg[data-temporary-fix] path {
        fill: ${colors.textWarning};
        stroke: none;
      }
    }
    &[data-error='true'] {
      svg:not(.shape) path {
        stroke: ${colors.red100};
      }
      svg.shape {
        color: ${colors.red100};
      }
      svg[data-temporary-fix] path {
        fill: ${colors.red100};
        stroke: none;
      }
    }
    &[data-disabled='true'] {
      svg:not(.shape) path {
        stroke: ${colors.iconSubtle};
      }
      svg.shape {
        color: ${colors.iconSubtle};
      }
      svg[data-temporary-fix] path {
        fill: ${colors.iconSubtle};
        stroke: none;
      }
    }
    &[data-loading='true'] {
      width: ${pxToRem(56)};
    }
  }

  &&& {
    // EMPTY STYLINGS
    &[data-empty='true'] {
      box-shadow: none;
      background: ${colors.white};
      border: dashed ${spacing.single} ${colors.borderInteractive};
      color: ${colors.textLink};
      &:hover {
        background: ${colors.backgroundInteractive};
        border: dashed ${spacing.single} ${colors.borderInteractiveSubtle};
        color: ${colors.textInteractive};
      }
      &:focus {
        background: ${colors.backgroundInteractive};
        border: dashed ${spacing.single} ${colors.borderInteractive};
        color: ${colors.textInteractive};
      }
    }
    &[data-empty='false'] {
      box-shadow: none;
      background: ${colors.backgroundInteractive};
      border: solid ${spacing.single} ${colors.borderInteractiveSubtle};
      color: ${colors.purple100};
  
      &:hover {
        border-color: ${colors.borderInteractive};
      }
      &:focus {
        border: solid ${spacing.single} ${colors.borderInteractiveStrong};
      }
    }
    // WARNING STYLINGS
    &[data-warning='true'] {
      color: ${colors.textWarning};
      border: solid ${spacing.single} ${colors.borderWarningSubtle};
      background: ${colors.backgroundWarningSubtle};
      &:hover {
        background: ${colors.backgroundWarningSubtle};
        color: ${colors.textWarning};
        border: solid ${spacing.single} ${colors.borderWarning};
      }
      &:focus {
        background: ${colors.backgroundWarningSubtle};
        color: ${colors.textWarning};
        border: solid ${spacing.single} ${colors.borderInteractiveStrong};
      }
    }
    // ERROR STYLINGS
    &[data-error='true'] {
      background: ${colors.white};
      border: solid ${spacing.eighth} ${colors.borderDestructive};
      color: ${colors.textDestructive};

      &:hover {
        background: ${colors.backgroundDestructiveSubtle};
        color: ${colors.textDestructive};
        border: solid ${spacing.eighth} ${colors.borderDestructive};
      }
      &:focus {
        background: ${colors.backgroundDestructiveSubtle};
        color: ${colors.textDestructive};
        border: solid ${spacing.eighth} ${colors.borderInteractiveStrong};
      }
    }
    // DISABLED STYLINGS
    &[data-disabled='true'] {
      color: ${colors.textDisabled};
      border: solid ${spacing.single} ${colors.borderPrimarySubtle};
      background: ${colors.backgroundSecondary};

      &:hover {
        color: ${colors.textDisabled};
        border: solid ${spacing.single} ${colors.borderPrimarySubtle};
        background: ${colors.backgroundSecondary};
      }
      &:focus {
        color: ${colors.textPrimary};
        border: solid ${spacing.single} ${colors.borderPrimarySubtle};
        background: ${colors.backgroundSecondary};
      }
    }

    // GHOST STYLINGS
    &[data-ghost='true'] {
      box-shadow: none;
      border: none;
      background: none;
      color: ${colors.textLink};

      &:hover {
        border: none;
        background: none;
      }

      &:focus {
        border: none;
      }
    }
  }
`;
